import { z } from "zod";

export const AUDIENCE_CANDIDATES_PAGE_SIZE = 20;

const AUDIENCE_EMAIL_PATTERN_SOURCE =
  "(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9-]*\\.)+[A-Za-z]{2,}";

export const AUDIENCE_EMAIL_MONGO_PATTERN =
  `^\\s*${AUDIENCE_EMAIL_PATTERN_SOURCE}\\s*$`;

export const AudienceCandidateEmailSchema = z
  .string()
  .regex(new RegExp(`^${AUDIENCE_EMAIL_PATTERN_SOURCE}$`), "Invalid email");

export const AudienceCandidatesQuerySchema = z.object({
  page: z.coerce.number().int().positive().optional().default(1),
  search: z
    .string()
    .trim()
    .max(100, "Search must be 100 characters or fewer")
    .optional()
    .transform((value) => value || undefined),
});

export type AudienceCandidatesQueryDto = z.infer<
  typeof AudienceCandidatesQuerySchema
>;

export const AudienceCandidateSchema = z.object({
  id: z.string().min(1),
  name: z.string().nullable(),
  email: AudienceCandidateEmailSchema,
  phone: z.string().nullable(),
});

export type AudienceCandidateDto = z.infer<typeof AudienceCandidateSchema>;

export const AudienceCandidatesResponseSchema = z.object({
  items: z.array(AudienceCandidateSchema),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.literal(AUDIENCE_CANDIDATES_PAGE_SIZE),
  totalPages: z.number().int().nonnegative(),
});

export type AudienceCandidatesResponseDto = z.infer<
  typeof AudienceCandidatesResponseSchema
>;
